export enum IdentificationType {
  Cedula = "D",
  Pasaporte = "E",
  International = "I",
  Menor = "M",
  RNC = "J",
}

export enum IdentificationTypeDescription {
  Cedula = "Cédula",
  RNC = "RNC",
  Passport = "Pasaporte",
}
